import SimpleLightbox from 'simplelightbox';
new SimpleLightbox('.lightbox', {
    captionSelector: 'self',
    captionsData: 'data-lightbox-caption',
    captionPosition: 'outside',
    fadeSpeed: 150,
    animationSpeed: 150,
    scrollZoom: false,
    uniqueImages: false
});
